import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// components

import UserSidebar from "../Components/Sidebar/UserSidebar.js";
// views
import Profile from "../views/user/Profile.js"
import Projects from "../views/user/Projects.js"

export default function User() {
  return (
    <>
      <div className="relative bg-blueGray-100">
        <UserSidebar />
        <div className="w-full">
          <Switch>
            <Route path="/user/profile" exact component={Profile} />
            <Route path="/user/projects" exact component={Projects} />
            {/* <Route path="/admin/settings" exact component={Settings} />
            <Route path="/admin/issues" exact component={Issues} />
            <Route path="/admin/new_issue" exact component={NewIssue} /> */}
            <Redirect from="/user" to="/user/projects" />
          </Switch>
        </div>
      </div>
    </>
  );
}
